import { render, staticRenderFns } from "./BetgameEditTeamsCompetitions.vue?vue&type=template&id=2b24800c&scoped=true"
import script from "./BetgameEditTeamsCompetitions.vue?vue&type=script&lang=js"
export * from "./BetgameEditTeamsCompetitions.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditTeamsCompetitions.vue?vue&type=style&index=0&id=2b24800c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b24800c",
  null
  
)

export default component.exports